<template>
    <div class="pdf">
        <div v-loading="isLoading" class="pdf_content">
            <el-image class="pdfImg" style="width: 715px; height: 538px;" :src="curPath" :preview-src-list="srcList"/>
        </div>
        <div class="page">
            <el-pagination :current-page="curPageIndex" layout="jumper,prev,slot,next" :page-size="1" :total="rscPageSize"  @current-change="handleCurrentChange" prev-text="阅读上一页" next-text="阅读下一页">
                <span> 当前 第 {{ curPageIndex }} 页</span>
                <span style="margin-left: 5px;">共{{rscPageSize}}页</span>
            </el-pagination>
        </div>
    </div>
</template>
<script>
  import { getRscPdfImage } from '@/api/player';

  export default {
    name: 'PDFPlayer',
    props: ['rscId', 'ifBuy', 'ifFree'],
    data() {
      return {
        srcList: [''],
        rscPath: '',
        rscPageSize: 0,
        curPageIndex: 1,
        totalCount: 0,
        curPath: '',
        count:5,
        isLoading: false
      };
    },
    mounted() {
      this.getPdfImage();
    },
    methods: {
      async getPdfImage() {
        this.isLoading = true;
        await getRscPdfImage({
          rscID: this.rscId
        }).then(data => {
          if (data.success) {
            this.isLoading = false;
            this.rscPath = data.result.rscNewPath;
            this.rscPageSize = data.result.rscPageSize;
            this.updateCurPath();
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      updateCurPath() {
        this.curPath = this.rscPath + '_' + this.curPageIndex + '.jpg';
        this.srcList[0] = this.curPath;
      },
      handleCurrentChange(val) {
        this.isLoading = true;
        if(val > 3 && !this.ifBuy)  {
          this.$message.warning('购买资源查看全部内容');
          document.getElementsByClassName("btn-next")[0].setAttribute("disabled","disabled");
          this.isLoading = false;
          return false;
        }
        else {
          document.getElementsByClassName("btn-next")[0].removeAttribute("disabled");
        }
        this.curPageIndex = val;
        this.updateCurPath();
        this.isLoading = false;
      }
    }
  };
</script>
